'use client';
import styled from '@emotion/styled';
import Slider from '@mui/material/Slider';

export const BaseSlider = styled(Slider)();
